import packageJson from '../../../package.json';

const useGetVersion = () => {
  return packageJson.version;
};

export { useGetVersion };
